Vue.component("Logo", {
    props: ["settings"],
    template: `
        <div id="logo" @click="navigateTo">
            <img v-for="logo in versions" :src="logo.src" :alt="alt" v-if="isLogoVisible(logo.name)">
        </div>
    `,
    data() {
        return {
            // variables defined in config.js
            src: this.settings.src,
            alt: this.settings.alttext,
            navigatesTo: this.settings.navigatesTo,
            versions: this.settings.versions,
            useLogoVersionOnRoute: this.settings.useLogoVersionOnRoute
        }
    },
    methods: {
        isLogoVisible (name) {
            
            // hvis vi tester alle med navn vil default altid være synlig.
            // bliver nød til at teste om der er noget i sættet der matcher først.
            const route = this.$route.path;

            // Find first match and then see if the name matches the argument.
            for(var i = 0; i < this.useLogoVersionOnRoute.length; i++) {

                const entity = this.useLogoVersionOnRoute[i];
                for(var j = 0; j < entity.match.length; j++) {
                    const pattern = new RegExp(entity.match[j], "gi");
                    let isMatch = pattern.test(route)
                    console.log(`testing pattern ${pattern} against route ${route}, match: ${isMatch}`)

                    if(isMatch) {
                        
                        return entity.name === name;
                    }
                }
            }
            return false;
        },
        navigateTo () {
            if(app.data.settings.find(el => el.id === 'defaultRoute').value !== this.$router.currentRoute.path)
                this.$router.push(app.data.settings.find(el => el.id === 'defaultRoute').value);
        },
        openLink(url) {
            // open external link if navigatesto is an external url
            window.open(url, "_blank");
        }
    }
})